import { Injectable } from '@angular/core';
import { ActiveCartService, CartAdapter } from '@spartacus/cart/base/core';
import { WindowRef } from '@spartacus/core';
import { PageLayoutHandler } from '@spartacus/storefront';
import { combineLatest, map, Observable, of, switchMap } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { KnBrCommonService } from '../services/kn-br-common.service';
import { KnBrCartContextService } from '../store/kn-br-cart-context/kn-br-cart-context.service';

@Injectable({
  providedIn: 'root',
})
export class SalesCartPagelayoutHandler implements PageLayoutHandler {
  constructor(
    protected activeService: ActiveCartService,
    protected cartAdapter: CartAdapter,
    protected winRef: WindowRef,
    protected commonService: KnBrCommonService,
    private knBrCartContextService: KnBrCartContextService
  ) {}

  private isRfqCart(cart: any): boolean {
    const cartCategoryBrand = String((cart as any).cartCategoryBrand || '').toLowerCase();
    return cartCategoryBrand.includes('request a quote');
  }

  handle(slots$: Observable<string[]>, pageTemplate?: string, section?: string) {
    if (pageTemplate === 'CarlisleSalesCartsPageTemplate' && !section) {
      this.commonService.showSpinner$.next(true);

      const cartData$ = this.knBrCartContextService.get$.pipe(
        switchMap((cartId) => {
          if (!cartId) {
            return of({ cart: null, entries: [] });
          }
          return this.cartAdapter.loadAll('current').pipe(
            map((carts) => {
              const firstCart = carts && carts.length ? carts[0] : null;
              const entries = firstCart && Array.isArray(firstCart.entries) ? firstCart.entries : [];
              return { cart: firstCart, entries };
            }),
            catchError(() => of({ cart: null, entries: [] }))
          );
        })
      );

      return combineLatest([
        slots$,
        cartData$,
        this.activeService.getLoading(),
      ]).pipe(
        map(([slots, { cart, entries }, loadingCart]) => {
          const exclude = (arr, args) => arr.filter((item) => args.every((arg) => arg !== item));
          this.commonService.showSpinner$.next(false);
          
          if (!this.winRef.isBrowser()) {
            return slots;
          }
          const isRfq = cart && this.isRfqCart(cart);
          if (entries.length > 0) {
            if (isRfq)
              return exclude(slots, ['BodyContent', 'TopContent']);
            else
              return exclude(slots, ['BodyContent', 'RfqContent']);
          } else
            return exclude(slots, ['TopContent', 'RfqContent']);
        })
      );
    }
    return slots$;
  }

}
